import * as TK from 'components/site/CoverImage/translations/constants';
import { Translations } from 'translations/types';

export const coverImageEnUsLocale: Translations = {
  [TK.COVER_IMAGE_PICTURE_ICON_ALT]: 'cover_image_icon',
  [TK.COVER_IMAGE_PHOTO_ALT]: 'cover_image',
};
